module.exports = __webpack_public_path__ + "static/media/3.83d7c641.jpg";